module.exports = __webpack_public_path__ + "img/circle.57cae029.png";